import "./tailwind.css";
import type React from "react";
import ErrorBoundary from "#components/errors/ErrorBoundary.tsx";

export default function LayoutDefault({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<ErrorBoundary>
			<div className="w-full min-h-screen">{children}</div>
		</ErrorBoundary>
	);
}
